import { PRODUCTS_LIVE } from '@/lib/site-stats';

export type EmblemId = 'tablesharp' | 'fetti' | 'powderledger';

export interface ClientEntry {
  name: string;
  url?: string;
  emblem?: EmblemId;
}

export const CLIENT_ROSTER: ReadonlyArray<ClientEntry> = [
  { name: 'PTO Ski & Snowboarding', emblem: 'powderledger', url: 'https://powderledger.com' },
  { name: 'Fetti', emblem: 'fetti', url: 'https://fetti.tips' },
  { name: 'TableSharp', emblem: 'tablesharp', url: 'https://tablesharp.com' },
  { name: 'CannaTrack Enterprise' },
  { name: 'Heather & Joe Wedding' },
  { name: 'Justice Ledger SaaS' },
  { name: 'THRAXON Strategy Game', url: 'https://thraxon.app' },
  { name: 'SOLTIDE Mobile RPG' },
];

export const HERO_NAMED_CLIENTS: ReadonlyArray<ClientEntry> = CLIENT_ROSTER.slice(0, 4);

export const MARQUEE_CLIENTS: ReadonlyArray<ClientEntry> = CLIENT_ROSTER;

// The hero trust strip renders "{LIVE_PRODUCT_COUNT} products live" — so this
// must be the LIVE count (6), not the roster length (8). Sourced from the
// canonical constant so it can't drift from the byline / stat strip.
export const LIVE_PRODUCT_COUNT = PRODUCTS_LIVE;
